/**
 * @providesModule Armap
 * Created by jacky on 2/26/16.
 */
const $fKeys = Object.keys;
const $fAProtoPush = Array.prototype.push;
const $fAProtoSlice = Array.prototype.slice;
const $fAProtoSplice = Array.prototype.splice;
const $fAProtoIndexOf = Array.prototype.indexOf;
const $fAProtoEach = Array.prototype.forEach;
const $fAProtoReduce = Array.prototype.reduce;
const $fAProtoMap = Array.prototype.map;
export default class Armap<K, T> {
    constructor(pkey /*TPrimaryKey<T>*/, indexes /*TIndexes<T> | string[] | string*/) {
        this._map = Object.create(null);
        this._indexes = [];
        this._getters = [];
        this._defaults = [];
        this.__indexes = Object.create(null);
        this.length = 0;
        this.lastUpdate = 0;
        // store key and index definition to clone for response
        this.__store = {
            key: pkey,
            indexes: indexes
        };
        this._key = pkey || 'id';
        if (indexes) {
            if (indexes instanceof Array) {
                this._indexes = indexes;
            }
            else if (typeof indexes == 'string') {
                this._indexes = [indexes];
            }
            else {
                $fKeys(indexes).forEach((fieldName) => {
                    this._indexes.push(fieldName);
                    this._getters.push(indexes[fieldName] instanceof Function ? indexes[fieldName] : void 0);
                    this._defaults.push(indexes[fieldName] instanceof Function ? void 0 : indexes[fieldName]);
                });
            }
        }
        this._init();
    }
    /**
     * Put indexes in corresponding place
     * @private
     * @param {string} k
     * @param {string} key
     * @param {string} $id
     */
    _push2Indexes(k, key, $id) {
        if (!(key in this.__indexes[k])) {
            this.__indexes[k][key] = [];
        }
        this.__indexes[k][key].push($id);
    }
    ;
    /**
     * remove helper
     * @private
     * @param {!Object} item
     * @param {string?} key
     */
    _removeIndexes(item, key) {
        const _key = key || this._getKey(item);
        this._indexes.forEach((k, i) => {
            let c = item[k] || this._defaults[i];
            c = this._getters[i] ? this._getters[i].call(this, c, item) : c;
            if (c instanceof Array) {
                c.forEach((v) => {
                    const a = this.__indexes[k][v];
                    const i = a ? a.indexOf(_key) : -1;
                    i > -1 && a.splice(i, 1);
                    if (a && a.length == 0) {
                        delete this.__indexes[k][v];
                    }
                });
            }
            else if (c !== undefined) {
                const a = this.__indexes[k][c];
                const i = a ? a.indexOf(_key) : -1;
                i > -1 && a.splice(i, 1);
                if (a && a.length == 0) {
                    delete this.__indexes[k][c];
                }
            }
        });
    }
    ;
    /**
     * Return IDs by aggregate indexes
     * @param {!Object} keys
     * @return {Array.<string>}
     */
    _getIDsByKeys(keys) {
        let ids = [];
        let forcedEnd = false;
        $fKeys(keys).forEach((key) => {
            const val = keys[key];
            let nv = [];
            if (val instanceof Array) {
                val.forEach((v) => {
                    let r = this.__indexes[key][v];
                    if (r !== undefined) {
                        $fAProtoPush.apply(nv, r);
                    }
                    else {
                        forcedEnd = true;
                    }
                });
            }
            else {
                if (this.__indexes[key]) {
                    nv = this.__indexes[key][val];
                    if (nv == undefined) {
                        nv = [];
                        forcedEnd = true;
                    }
                }
                else {
                    nv = [];
                    forcedEnd = true;
                }
            }
            ids = ids.length > 0 ? $intersect(ids, nv) : nv;
        });
        return forcedEnd ? [] : ids;
    }
    ;
    /**
     * Return key for item
     * @param {Object} item
     * @param {string?} key
     * @return {string}
     */
    _getKey(item, key) {
        let _key = key !== void 0 ? key : this._key;
        if (_key instanceof Function) {
            return _key.call(this, item);
        }
        else {
            return item[_key];
        }
    }
    /**
     * Check keys against the item
     * @param {Object} keys
     * @param {Object} item
     * @return {boolean}
     */
    _checkKeys(keys, item) {
        for (let k in keys) {
            const v = keys[k] instanceof Function ? keys[k].call(this, k, item) : keys[k];
            if (v == item[k]) {
                return true;
            }
        }
        return false;
    }
    /**
     * Initiate indexes
     */
    _init() {
        this.__indexes = Object.create(null);
        /** Prepare namespaces for indexes */
        this._indexes.forEach((k) => {
            this.__indexes[k] = Object.create(null);
        });
    }
    /**
     * Create Armap object from exists array
     * @param {string|function} key
     * @param {Object|Array<string>|string} opts
     * @param {Array} src
     * @returns {Armap<T>}
     */
    static fromArray(key, src, opts) {
        let r = new Armap(key, opts);
        $fAProtoPush.apply(r, src);
        r.reindex();
        return r;
    }
    /**
     * Push item to array.
     * @param {Object} item
     * @param {string} key
     * @returns {number}
     */
    push(item, key) {
        const $id = key || this._getKey(item);
        const old = this._map[$id];
        if (old) {
            this._removeIndexes(this._map[$id]);
            const i = this.indexOf($id);
            this[i] = this._map[$id] = item;
        }
        else {
            const idx = $fAProtoPush.call(this, item);
            this._map[$id] = this[idx - 1];
        }
        this._indexes.forEach((k, i) => {
            let key = item[k] !== undefined ? item[k] : this._defaults[i];
            this._getters[i] && (key = this._getters[i].call(this, key, item));
            if (key instanceof Array) {
                key.forEach((v) => {
                    this._push2Indexes(k, v, $id);
                });
            }
            else if (key !== undefined) {
                this._push2Indexes(k, key, $id);
            }
        });
        this.lastUpdate = Date.now();
        return this.length;
    }
    /**
     * Cast Armap to array object
     * @returns {Array}
     */
    asArray() {
        return $fAProtoSlice.call(this);
    }
    /**
     * Recreate indexes
     */
    reindex() {
        this._init();
        this.asArray().forEach((item) => {
            const $id = this._getKey(item);
            this._map[$id] = item;
            this._indexes.forEach((k, i) => {
                let key = item[k] !== undefined ? item[k] : this._defaults[i];
                this._getters[i] && (key = this._getters[i].call(this, key, item));
                if (key instanceof Array) {
                    key.forEach((v) => {
                        this._push2Indexes(k, v, $id);
                    });
                }
                else if (key !== undefined) {
                    this._push2Indexes(k, key, $id);
                }
            });
        });
        this.lastUpdate = Date.now();
    }
    /**
     * Remove item from Armap
     * @param {string} key
     */
    remove(key) {
        const item = this._map[key];
        if (!item) {
            return;
        }
        this._removeIndexes(item, key);
        const i = $fAProtoIndexOf.call(this, item);
        i > -1 && $fAProtoSplice.call(this, i, 1);
        delete this._map[key];
        this.lastUpdate = Date.now();
    }
    /**
     * Remove items by index
     * @param index
     */
    removeByIndex(index) {
        const keys = this._getIDsByKeys(index).slice();
        keys.forEach((k) => {
            this.remove(k);
        });
    }
    /**
     * Clear the collection by filter
     * @param {function?} callback
     */
    empty(callback) {
        if (callback) {
            let i = 0;
            while (i < this.length) {
                const r = callback.call(this, this[i], i);
                const key = this._getKey(this[i]);
                if (r) {
                    this.remove(key);
                }
                else {
                    i++;
                }
            }
        }
        else {
            this.length = 0;
            this._map = Object.create(null);
            this._init();
        }
        this.lastUpdate = Date.now();
    }
    byId(key) {
        return this._map[key];
    }
    /**
     * return aggregated keys
     * @param {string} keyName
     * @param {string=} value
     * @return {Array.<string>}
     */
    aggregatedKeys(keyName, value) {
        if (arguments.length == 2) {
            return this.__indexes[keyName] && this.__indexes[keyName][value] || [];
        }
        else {
            return $fKeys(this.__indexes[keyName]);
        }
    }
    /**
     * return keys by aggregate key
     * @param {Object} keys
     * @return {Array.<string>}
     */
    keysByAggregateKey(keys) {
        return this._getIDsByKeys(keys);
    }
    /**
     * Return values by aggregate key
     * @param {Object} keys
     * @param {Array|Armap} responseType
     * @param {function} mapFunc
     * @return {Array.<Object>}
     */
    valuesByAggregateKeys(keys, responseType, mapFunc) {
        const r = responseType || new Armap(this.__store.key, this.__store.indexes);
        this._getIDsByKeys(keys).forEach((v) => {
            r.push.call(r, mapFunc && mapFunc.call(null, this._map[v]) || this._map[v]);
        });
        return r;
    }
    /**
     * @param {string} id
     * @return {Object}
     */
    indexOf(id) {
        return $fAProtoIndexOf.call(this, this._map[id]);
    }
    /**
     * Hash list
     * @return {Object.<string, Object>}
     */
    hash() {
        return this._map;
    }
    /**
     * Mapping each element and return in requested form
     * @param {function} callback
     * @param {Armap|Array=} resultType
     * @param {boolean} skipUndefined
     * @return {Armap|Array}
     */
    map(callback, resultType = [], skipUndefined = true) {
        $fAProtoEach.call(this, (v, i) => {
            let rr = callback.call(this, v, i);
            if (skipUndefined && rr === undefined) {
                return;
            }
            resultType.push(rr);
        });
        return resultType;
    }
    /**
     * Filter each element against callback and return in requested form
     * @param {function} callback
     * @param {Armap|Array=} resultType
     * @return {Armap|Array}
     */
    filter(callback, resultType = []) {
        $fAProtoEach.call(this, (v, i) => {
            let rr = callback.call(this, v, i);
            if (!rr) {
                return;
            }
            resultType.push(v);
        });
        return resultType;
    }

    concat<U>(src: Array<U>) {
        src.forEach(d => {
            this.push(d);
        })
    }
}

export function $intersect(...args) {
    let aLower = [];
    let aStack = [];
    let count;
    let i;
    let nArgs;
    let nLower;
    let oRest = {};
    let oTmp = {};
    let value;
    let indexes = (array, oStack) => {
        var i = 0;
        let value;
        let nArr = array.length;
        let oTmp = {};
        for (; nArr > i; ++i) {
            value = array[i];
            if (!oTmp[value]) {
                oStack[value] = 1 + (oStack[value] || 0); // counter
                oTmp[value] = true;
            }
        }
        return oStack;
    };
    args.sort((a, b) => {
        return (a.length - b.length);
    });
    aLower = args.shift();
    nLower = aLower.length;
    if (0 === nLower) {
        return aStack;
    }
    nArgs = args.length;
    i = nArgs;
    while (i--) {
        oRest = indexes(args.shift(), oRest);
    }
    for (i = 0; nLower > i; ++i) {
        value = aLower[i];
        count = oRest[value];
        if (!oTmp[value]) {
            if (nArgs === count) {
                aStack.push(value);
                oTmp[value] = true;
            }
        }
    }
    return aStack;
}
export function $union<T>(array1: Array<T>, array2: Array<T>): Array<T> {
    let obj = {};
    let i = array1.length;
    let j = array2.length;
    let newArray = [];
    while (i--) {
        if (!(array1[i] in obj)) {
            obj[array1[i]] = true;
            newArray.push(array1[i]);
        }
    }
    while (j--) {
        if (!(array2[j] in obj)) {
            obj[array2[j]] = true;
            newArray.push(array2[j]);
        }
    }
    return newArray;
}

//function $map ($array: Array<any>, callback: (el:any, i:number) => any, result: Array<any> | IArmap<any> = [], skipUndefined: boolean = false): Array<any> | IArmap<any> {
//    let p = result instanceof Armap ? result.$push : result.push;
//
//    for (let rr, l = $array.length, i = 0; i < l; i++) {
//        rr = callback.call($array, $array[i], i);
//        if (skipUndefined && rr === undefined) { continue; }
//        p(rr);
//    }
//
//    return result;
//}
//
//function $filter ($array: Array<any>, callback: (el: any, i:number) => any, result: Array<any> | IArmap<any> = []) {
//    for (let rr, l = $array.length, i = 0; i < l; i++) {
//        rr = callback.call($array, $array[i], i);
//        if (rr == true) {
//            result.push($array[i]);
//        }
//    }
//
//    return result;
//}
export function $concat<T>(array1: Array<T>, array2: Array<T>): Array<T> {
    let r = new Array(array1.length + array2.length);
    let idx = 0;
    [array1, array2].forEach(function (src) {
        for (let l = src.length, i = 0; i < l; i++) {
            r[idx++] = src[i];
        }
    });
    return r;
}
export function $unique<T>($src: Array<T>): Array<T> {
    // let tmp = Object.create(null);
    // for (let i = $src.length; --i >= 0;) {
    //     tmp[$src[i]] = true;
    // }
    return $fKeys($src.reduce((obj: Object, v: T) => {
        obj[v] = true;
        return obj;
    }, Object.create(null)));
}



// WEBPACK FOOTER //
// ./src/lib/armap.js